var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html } from "lit";
import { property } from "lit/decorators.js";
import { QboTemplate, template } from "@quandis/qbo4.configuration";
import { QboFetchMixin, getArray, formatDate, qboui } from "@quandis/qbo4.ui";
export class QboDecision extends QboFetchMixin(QboTemplate) {
    constructor() {
        super(...arguments);
        this.apiEndpoint = new URL("api://qbo3/decision");
        this.display = 25;
        this.start = 0;
        this.imagePath = window.qbo4['imagePath'] ?? '/ui/images/qbo-icons.svg';
        this.renderInHost = false;
        this.searchFilter = false;
        this.show = true;
        this.showInline = true;
        this.type = 'search';
        this.viewDecision = null;
    }
    static { this.styles = [
        qboui
    ]; }
    async connectedCallback() {
        if (Object.keys(this.dataset).length > 0)
            this.payload = { ...this.dataset };
        switch (this.type) {
            case "search":
                this.apiEndpoint = new URL("api://qbo3/decision/search");
                break;
        }
        super.connectedCallback();
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    createRenderRoot() {
        return this.renderInHost ? this : super.createRenderRoot();
    }
    filterKeyDown(e) {
        this.filterData = null;
        this.shadowRoot?.querySelectorAll('tr.qbo-filter').forEach(tr => {
            tr.querySelectorAll('input').forEach(input => {
                if (input instanceof HTMLInputElement && input.value.trim() != '') {
                    if (!this.filterData)
                        this.filterData = {};
                    this.filterData[input.name] = input.value;
                }
            });
        });
    }
    async paginate(e) {
        if (this.payload == null)
            this.payload = {};
        this.payload['DisplaySize'] = e.detail['display'];
        this.payload['RecordStart'] = e.detail['start'];
        const currentDisplay = this.display;
        this.display = Number(this.payload['DisplaySize']);
        const currentStart = this.start;
        this.start = Number(this.payload['RecordStart']);
        const count = Number(getArray(this.jsonData)?.[0]?.RecordCount) || 0;
        if (count > 0 && (currentDisplay != this.display || currentStart != this.start))
            await this.fetchData(this.headers ?? {}, this.payload);
    }
    view(task, e) {
        e.preventDefault();
        this.viewDecision = task;
    }
    closeViewer() {
        this.viewDecision = null;
    }
    search(component) {
        const json = getArray(component.jsonData);
        const count = Number(json?.[0]?.RecordCount) || json?.length || 0;
        const length = json?.length || 0;
        const jsonPage = length > component.display ? json?.slice(component.start, component.start + component.display) : json;
        return html `<slot>
<div class="qbo-row-viewer">
    <div class="qbo-col qbo-col-noborder">
        <table class="qbo-nowrap" data-drop>
            <thead>
                <tr>
                    <th>Workflow</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>User</th>
                    <th>Module</th>
                    <th>Name</th>
                </tr>
            </thead>
            <tbody>
                ${jsonPage ? jsonPage.map(item => html `
                    <tr>
                        ${component?.showInline
            ? html `<td><a href="/api/decision/${item.DecisionID}" @click=${(e) => component.view(item, e)}>${item.Decision}</a></td>`
            : html `<td>${item.Decision}</td>`}
                        <td>${formatDate(item.UpdatedDate)}</td>
                        <td>${formatDate(item.UpdatedDate, 'HH:mm:ss')}</td>
                        <td>${item.UpdatedPerson}</td>
                        <td>${item.Object}</td>
                        <td>${item.ParentLabel}</td>
                    </tr>
                `) : html `<tr><td colspan="6">No data available</td></tr>`}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="6">${json && json[0] ? html `<qbo-paginate count="${count}" @change=${(e) => component.paginate(e)}></qbo-paginate>` : html ``}</td>
                </tr>
            </tfoot>
        </table>
    </div>
    ${component?.viewDecision ? html `<qbo-resize></qbo-resize>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-module-viewer qbo-card">
            <h2>
                Workflow Details
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="${component.closeViewer}">x</button>
            </h2>
            <div class="qbo-form">
                <label>Workflow</label>
                <span>${component.viewDecision.Decision}</span>
                <label>Template</label>
                <span>${component.viewDecision.DecisionTemplate}</span>
            </div>
        </div>
    </div>` : html ``}
</div></slot>`;
    }
    searchTab(component) {
        let json = getArray(component.jsonData) ?? [];
        if (component.filterData) {
            json = json
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Decision) {
                    return item.Decision?.toLowerCase().includes(component.filterData.Decision.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Date) {
                    return formatDate(item.UpdatedDate)?.toLowerCase().includes(component.filterData.Date.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Time) {
                    return formatDate(item.UpdatedDate, 'HH:mm:ss')?.toLowerCase().includes(component.filterData.Time.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.User) {
                    return item.UpdatedPerson?.toLowerCase().includes(component.filterData.User.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Module) {
                    return item.Object?.toLowerCase().includes(component.filterData.Module.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Name) {
                    return item.ParentLabel?.toLowerCase().includes(component.filterData.Name.toLowerCase());
                }
                return true;
            });
        }
        const count = Number(json?.[0]?.RecordCount) || json?.length || 0;
        const length = json?.length || 0;
        const jsonPage = length > component.display ? json?.slice(component.start, component.start + component.display) : json;
        return html `<slot>
<div class="qbo-row-viewer">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-card-buttons">
            <button type="button" class="${component.searchFilter ? 'active' : ''}" @click="${(e) => component.searchFilter = !component.searchFilter}">
                <svg>
                    <use href="${component.imagePath}#search">
                </svg>
                Search
                <qbo-popover>
                    <h3>Search</h3>
                    <p>Toggle the search options to locate specific workflows.</p>
                </qbo-popover>
            </button>
        </div>
        <table class="qbo-nowrap" data-drop>
            <thead>
                <tr>
                    <th>Workflow</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>User</th>
                    <th>Module</th>
                    <th>Name</th>
                </tr>
            </thead>
            <tbody>
                ${component.searchFilter ? html `
                    <tr class="qbo-filter">
                        <td><input type="text" name="Decision" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Date" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Time" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="User" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Module" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Name" @keyup=${component.filterKeyDown}></input></td>
                    </tr>
                ` : html ``}
                ${jsonPage ? jsonPage.map(item => html `
                    <tr>
                        ${component?.showInline
            ? html `<td><a href="/api/decision/${item.DecisionID}" @click=${(e) => component.view(item, e)}>${item.Decision}</a></td>`
            : html `<td>${item.Decision}</td>`}
                        <td>${formatDate(item.UpdatedDate)}</td>
                        <td>${formatDate(item.UpdatedDate, 'HH:mm:ss')}</td>
                        <td>${item.UpdatedPerson}</td>
                        <td>${item.Object}</td>
                        <td>${item.ParentLabel}</td>
                    </tr>
                `) : html `<tr><td colspan="6">No data available</td></tr>`}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="6">${jsonPage && jsonPage[0] ? html `<qbo-paginate count="${count}" @change=${(e) => component.paginate(e)}></qbo-paginate>` : html ``}</td>
                </tr>
            </tfoot>
        </table>
    </div>
    ${component?.viewDecision ? html `<qbo-resize></qbo-resize>
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-module-viewer qbo-card">
            <h2>
                Workflow Details
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="${component.closeViewer}">x</button>
            </h2>
            <div class="qbo-form">
                <label>Workflow</label>
                <span>${component.viewDecision.Decision}</span>
                <label>Template</label>
                <span>${component.viewDecision.DecisionTemplate}</span>
            </div>
        </div>
    </div>` : html ``}
</div></slot>`;
    }
}
__decorate([
    property({ type: URL }),
    __metadata("design:type", Object)
], QboDecision.prototype, "apiEndpoint", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboDecision.prototype, "display", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboDecision.prototype, "filterData", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboDecision.prototype, "start", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboDecision.prototype, "imagePath", void 0);
__decorate([
    property(),
    __metadata("design:type", Boolean)
], QboDecision.prototype, "renderInHost", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboDecision.prototype, "searchFilter", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboDecision.prototype, "show", void 0);
__decorate([
    property(),
    __metadata("design:type", Boolean)
], QboDecision.prototype, "showInline", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboDecision.prototype, "type", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboDecision.prototype, "viewDecision", void 0);
__decorate([
    template('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboDecision]),
    __metadata("design:returntype", void 0)
], QboDecision.prototype, "search", null);
__decorate([
    template('searchTab'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboDecision]),
    __metadata("design:returntype", void 0)
], QboDecision.prototype, "searchTab", null);
if (!customElements.get('qbo-decision'))
    customElements.define('qbo-decision', QboDecision);
